export default "__VITE_ASSET__BgyQgvCS__"